import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const List = styled.ul`
  list-style: disc;
`

export const ListItem = styled.li`
  margin-bottom: ${Spacing.S6};
  margin-left: ${Spacing.S16};
`
